import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import Link  from 'components/Link';
import productAction from 'actions/Product';
import productsStore from 'stores/new/Products';
import ProductOffers from 'components/Home/CategoriesOffers/ProductOffers';
import BannerOffers from 'components/Home/CategoriesOffers/BannerCategoriesOffers';
import CategoryPromotionsOffers from 'components/Home/CategoriesOffers/BannerPromotionsOffers';
import TagManager from "services/TagManager";
import { actionsType } from 'config/constants';
import PubSub from 'services/PubSub';
import { sliderProductsTxt } from 'config/translate/variables';
import FavoritesActions from 'actions/Favorites'
import style from './style.scss';//NOSONAR

let actions = [];

const CategoriesOffersContainer = (props) => {
    const [products, setProducts] = useState([]);
    const {store, item} = props;
    let skus = {};

    let shelfIsland = item.shelfIsland ? item.shelfIsland : 0;

    useEffect(() => {
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => {
            setProducts([]);
            loadSkus(item.content);
            productAction.getProductsBySkus(skus);
        }));

        FavoritesActions.getFavorites(false);

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    useEffect(() => {
        loadSkus(item.content);
        productAction.getProductsBySkus(skus);
    },[item]);

    useEffect(() => {

        loadSkus(item.content);

        let prods = store && store.products ? store.products.get(JSON.stringify(skus)) : null;

        if(prods && prods.toList){
            prods = prods.toList().toArray();
            setProducts(prods);
        }
    }, [store]);

    const loadSkus = (_content) => {
        skus = {};
        const prods = _content.filter(_item => _item.acf_fc_layout === "products");
        if (prods.length) {
            prods.map(_item => _item.product[0].sku).map(sku => skus[sku] = { quantity: 1 });
        }
    }

    const getProducts = (_content) => { 
        let prod = null;
        let prods = []; 
        let productKey = 0; 
        let promo = 0; 

        _content && _content.length && _content.map((element) => { 

            if (element.acf_fc_layout === "products") { 
                prod = products.filter(elem => elem.items[0].itemId === element.product[0].sku); 

                if (!prod[0] || !prod.length ) return ''; 

                element.date_server = item.serverDate; 
                productKey++; 
                element.key = productKey;
                prods.push([element, prod[0]]); 
            }
            if(((element.acf_fc_layout === "promotions") || (element.acf_fc_layout === "banner") && element.banner_offer[0].active)) { 
                promo++; 
            } 
        });
        
        if(promo > 1 ) { 
            prods.length = 2; 
        } 
        else if(promo < 2 ) { 
            prods.length = 3; 
        } 
    
        return prods 
    }

    const clickTagManager = ()  => {
        TagManager.clickLink(sliderProductsTxt.viewMore, 'Products-Categories', item.title);
    }

    let content = item.content;
    let productsFiltered = getProducts(content).filter(Boolean).sort((a,b) => {
        return b[0].product[0].time - a[0].product[0].time
    }); 
    
    if (productsFiltered.length < 2) return '';

    return <section className="categories-offers">
        <div className="categories-offers-wrap-text">
            <div className="categories-offers-title">
                <strong>{item.title}</strong>
            </div>
            <Link className="new-link home-section-link" to={item.url} target={item.url_target} onClick={() => clickTagManager()}>
                <span className='home-section-link-text'>{sliderProductsTxt.viewMore}</span>
            </Link>
        </div>

        <div className="categories-offers-content-wrap">
            <ProductOffers products={productsFiltered} name={item.title} shelfIsland={shelfIsland}/>

            {content && content.length && content.map((element, i) => {
                if (element.acf_fc_layout && element.acf_fc_layout.length < 2) return '';

                if (element.acf_fc_layout) {
                    switch (element.acf_fc_layout) {
                        case 'promotions':
                        {
                            let banner = content.filter(elem => elem.acf_fc_layout === 'banner');
                            if(!banner || !banner.length || !(banner.length && banner[0].banner_offer[0].active)){
                                element.fullWidth = true;
                            }
                            return <CategoryPromotionsOffers item={element} key={i} shelfIsland={shelfIsland}/>;
                        }
                        case 'banner':
                        {
                            let promotion = content.filter(elem => elem.acf_fc_layout === 'promotions');
                            if(!promotion || !promotion.length){
                                element.fullWidth = true;
                            }
                            return ((element.banner_offer && element.banner_offer[0].active) && <BannerOffers item={element} key={i} shelfIsland={shelfIsland}/>);
                        }
                        default:
                            return '';
                    }
                }
            })}
        </div>
    </section>
    

};

CategoriesOffersContainer.propTypes = {
    title: PropTypes.string,
    productOptions: PropTypes.object,
    item: PropTypes.object,
    products: PropTypes.object,
    store : PropTypes.object
};

export default productsStore.wrapConsumer(CategoriesOffersContainer);
